export {
  FieldLabel,
  type FieldLabelProps,
  type IFieldLabelProps,
} from './field-label';
